module.exports = __webpack_public_path__ + "static/media/NvphInsectNet.af80b002.webp";